var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`Flag fflag ff-round fflag-${_vm.country} ff-md`})
}
var staticRenderFns = []

export { render, staticRenderFns }